import * as React from 'react';
import { cn } from '../../utils';
import './dropbox.scss';
import { useSelector } from '../../utils/useSelector';

export interface DropboxProps {
  className?: string;
  childClassName?: string;
  children?: any | ((setExpanded?: (e?: boolean) => void) => any);
  renderBox: (setExpanded?: (e?: boolean) => void) => any;
  position?: 'left' | 'right';
  forceShow?: boolean;
  defaultShow?: boolean;
  disabled?: boolean;
  onStateChanged?: (expanded: boolean) => void;
}

export const Dropbox = ({
  className,
  childClassName,
  children,
  forceShow,
  defaultShow,
  disabled,
  renderBox,
  onStateChanged,
  position
}: DropboxProps) => {
  const getMountPoint = useSelector(s => s.app?.elFn?.getMountPoint);
  const linkRef = React.useRef<HTMLDivElement>(null);
  const modalRef = React.useRef<HTMLDivElement>(null);
  const [expanded, _setExpanded] = React.useState(defaultShow);
  const setExpanded = (e: boolean) => {
    _setExpanded(e);
    if (onStateChanged) onStateChanged(e);
  };
  React.useEffect(() => {
    if (defaultShow && !expanded) setExpanded(true);
  }, [defaultShow]);
  const el = getMountPoint ? getMountPoint() : document;
  React.useEffect(() => {
    if (expanded || forceShow) {
      const handleClickOutside = event => {
        if (event.target?.getAttribute('class') == 'cpp-ui cpp-loader-overlay')
          return;
        if (!linkRef?.current?.contains(event.target) && !event?.target?.href) {
          setExpanded(false);
        }
      };
      el.addEventListener('mousedown', handleClickOutside);
      return () => {
        el.removeEventListener('mousedown', handleClickOutside);
      };
    }
  }, [el, expanded, forceShow]);

  const isFn = typeof children == 'function';
  return (
    <div
      ref={linkRef}
      className={cn(
        {
          'dropbox-disabled': disabled,
          'dropbox-show': expanded || forceShow,
          [className]: !!className,
          'dropbox-right': position == 'right',
          'dropbox-left': !position || position == 'left'
        },
        'dropbox'
      )}
    >
      <div onClick={disabled ? null : () => setExpanded(!expanded)}>
        {isFn ? children(setExpanded) : children}
      </div>
      <div>
        <div ref={modalRef} className={childClassName}>
          {(expanded || forceShow) && renderBox(setExpanded)}
        </div>
      </div>
    </div>
  );
};
